export const CANCEL_REASONS = {
	ENGAGEMENT: 'Het aanbod valt tegen/ik vind het niet aansprekend genoeg',
	SELECTION: 'Er is te weinig keuze qua series en films',
	FINDABILITY: 'Ik mis persoonlijke kijktips',
	COSTS: 'Ik vind het abonnement te duur',
	COMPATIBILITY: 'Videoland werkt niet op mijn (smart) TV/computer/mobiele telefoon/ander apparaat',
	STREAMING_QUALITY: 'Kwaliteit van de streaming voldoet niet aan de verwachting',
	PAUSE:
		'Ik ben tevreden, maar wil graag mijn abonnement tijdelijk pauzeren (bijv. vanwege vakantie)',
	FINISHED: 'Serie of film is afgelopen, of deze is niet meer beschikbaar',
	MALFUNCTION: 'Video’s spelen niet goed af/veel storingen geweest',
};

export const CANCEL_RECONSIDER = {
	YES: 'Ja',
	NO: 'Nee',
	UNKNOWN: 'Weet ik niet',
};

export const CANCEL_FEEDBACK =
	'Jammer dat je wilt opzeggen. Opzeggen doe je zelf via je accountomgeving. Klik <a href="/mijn-abonnement">HIER</a> om naar je account te gaan.';

export const CANCELLATION_BLOCKED_REASON = {
	ALREADY_CANCELLED: 'ALREADY_CANCELLED',
	EXPIRED: 'EXPIRED',
	IS_TRUSTED_PARTY_SUBSCRIPTION: 'IS_TRUSTED_PARTY_SUBSCRIPTION',
	IS_TERMED_SUBSCRIPTION: 'IS_TERMED_SUBSCRIPTION',
	IS_FREE_SUBSCRIPTION: 'IS_FREE_SUBSCRIPTION',
};
